import { MemberJourneyListType } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { FilmThumbnailMediaType } from '../../film/thumbnail/types/media-type';
export { MemberJourneyListType };
export const defaultMemberJourneyListConfig = {
    listType: MemberJourneyListType.Active,
    filmMediaType: FilmThumbnailMediaType.Poster,
    numberOfJourneysToLoad: 10,
    showMessageForEmptyList: true
};
export const memberJourneyListConfigValidator = Validator.object({
    listType: Validator.oneOf(Object.values(MemberJourneyListType)),
    filmMediaType: Validator.oneOf(Object.values(FilmThumbnailMediaType)),
    numberOfJourneysToLoad: Validator.number({ min: 1 }),
    showMessageForEmptyList: Validator.boolean()
});
